.content{margin:0;color:var(--color-fg-secondary);font-size:14px;line-height:1.6}
/*# sourceMappingURL=confirmation-popup-NY7PLT3F.css.map */
